import React, { Fragment, type FunctionComponent } from 'react'
import {
  fontSize,
  Modal,
  Text,
  TextButton,
  useBooleanState,
} from '@retailer-platform/shared-components'
import { css } from '@emotion/react'
import { useDomainMessages } from 'domains/collections/utils/domain/intl'
import { type GetCollectionQuery } from 'domains/collections/api'
import { CollectionsRuleViewProducts } from 'domains/collections/components/collections-form/components/rules/CollectionsRuleViewProducts'

interface Props {
  subject: GetCollectionQuery['collection']['subjects'][0]
}

const removeMarginStyles = css({
  marginLeft: 0,
})

const textButtonStyles = css({
  fontSize: fontSize.X15,
})

const inlineBlock = css({
  display: 'inline-block',
})

export const collectionsViewRuleIsProductsList = (
  rule: GetCollectionQuery['collection']['subjects'][0]
): boolean => rule.criteriaProductIds.length > 0

export const CollectionsViewRuleProductsList: FunctionComponent<Props> = ({ subject }) => {
  const [viewProductsModalOpen, openViewProductsModal, closeViewProductsModal] =
    useBooleanState(false)

  const messages = useDomainMessages(
    {
      viewProductsHeader:
        'collectionsDomain.collectionsForm.section.rules.productCodes.viewProducts.header',
      label: 'collectionsDomain.view.content.rule.productCodes.label',
      productCount: 'collectionsDomain.view.content.rule.productCodes.count',
    },
    { count: subject.criteriaProductIds.length }
  )

  return (
    <Fragment>
      <Text
        data-testid={`collections-view-rule-products-list-${subject.id}`}
        styles={css(removeMarginStyles, inlineBlock)}
        size="medium"
      >
        {messages.label}
      </Text>
      <TextButton
        css={css(removeMarginStyles, textButtonStyles, inlineBlock)}
        onClick={openViewProductsModal}
      >
        {messages.productCount}
      </TextButton>
      <Modal
        maxWidth={800}
        isOpen={viewProductsModalOpen}
        onRequestClose={closeViewProductsModal}
        headerContent={messages.viewProductsHeader}
        bodyContent={<CollectionsRuleViewProducts productIds={subject.criteriaProductIds || []} />}
      />
    </Fragment>
  )
}
